import signinWithEmail from "api/auth/email/signinWithEmail";
import signupWithEmail from "api/auth/email/signupWithEmail";
import { ModalTypes } from "features/Modal/modalTypes";
import { setModal } from "features/Modal/slice";
import { useCallback } from "react";
import { useAppDispatch } from "redux/hooks";

export function useEnterWithEmail(inputValue: string): {
  handleSignin: () => Promise<void>;
  handleSignup: () => Promise<void>;
} {
  const dispatch = useAppDispatch();

  const openModal = ({
    type,
    modalProps,
  }: {
    type: ModalTypes;
    modalProps?: any;
  }) => {
    dispatch(setModal({ type, modalProps }));
  };

  const handleSignin = useCallback(async () => {
    let destinationPath = "";
    const urlSearchParams = new URLSearchParams(window.location.search);
    const subdomainInSearch = urlSearchParams.get("subdomain");
    let res;
    if (subdomainInSearch) {
      const pathAfterSignIn = urlSearchParams.get("path");
      if (pathAfterSignIn) {
        destinationPath = encodeURIComponent(pathAfterSignIn);
      }
      res = await signinWithEmail({
        emailAddress: inputValue,
        workspaceEid: subdomainInSearch,
        destinationPath,
      });
    } else {
      res = await signinWithEmail({
        emailAddress: inputValue,
      });
    }
    if (res.status === 204) {
      openModal({
        type: ModalTypes.CheckEmail,
        modalProps: {
          email: inputValue,
        },
      });
    } else {
      openModal({
        type: ModalTypes.UnexpectedError,
      });
    }
  }, [inputValue]);

  const handleSignup = useCallback(async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const demoMockUserId = getDemoMockUserId(urlSearchParams);
    const acquisitionSource = getAcquisitionSource(urlSearchParams);
    const acquisitionCampaign = getAcquisitionCampaign(urlSearchParams);
    const res = await signupWithEmail({
      emailAddress: inputValue,
      referralCode: urlSearchParams.get("referralCode") || undefined,
      demoMockUserId,
      acquisitionSource,
      acquisitionCampaign,
    });
    if (res.status === 204) {
      openModal({
        type: ModalTypes.CheckEmail,
        modalProps: {
          email: inputValue,
        },
      });
    } else {
      openModal({
        type: ModalTypes.UnexpectedError,
      });
    }
  }, [inputValue]);

  return { handleSignin, handleSignup };
}

function getDemoMockUserId(urlSearchParams: URLSearchParams) {
  const demo_mock_user_id = urlSearchParams.get("demo_mock_user_id");
  return demo_mock_user_id || undefined;
}

function getAcquisitionSource(urlSearchParams: URLSearchParams) {
  const utm_source = urlSearchParams.get("utm_source");
  return utm_source || undefined;
}

function getAcquisitionCampaign(urlSearchParams: URLSearchParams) {
  const utm_campaign = urlSearchParams.get("utm_campaign");
  return utm_campaign || undefined;
}
